import Model from './model';

export default class Industry extends Model {
  static NAME = 'industry';
  static COLLECTION_NAME = "industries";
  static URL = '/api/v2/industries';

  static SUGGESTIONS = [
    'Corporate Services',
    'Financials',
    'Government',
    'Manufacturing',
    'Media',
    'Non-Profit',
    'Retail',
    'Technology',
    'Transportation',
  ]
};